<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import uploadFileplus from '../../../common/uploadFileplus/index.vue';
import {
	templategetTemplate,
	deleteMappingTemplateConfig,
	uploadTemplateText,
	getColumnNames,
	saveOrUpdateMappingTemplateConfig,
	getTemplateConfig
} from '../../../../api/home.js';
export default {
	name: 'VoucherTemplates',
	components: {
		uploadFileplus
	},
	data() {
		return {
			title: '',
			searchlist: getdata().searchlist,
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('VoucherTemplatesheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('VoucherTemplatesoutlist')) || [],
			shaidiag: false,
			searchdata: getdata().searchdata,
			tableData: [],
			tablekey: 0,
			overlength: 0,
			searchdiag: false,
			//编辑弹框
			Compile: false,
			headDatays: getdata().headDatays,
			tableDatays: [],
			headDatapz: getdata().headDatapz,
			tableDatapz: [],
			options: [],
			//导入
			updiag: false,
			formlist: getdata().formlist,
			formdata: {
				textSplitType: ''
			},
			upfile: {
				formdata: {
					textSplitType: ''
				}
			},
			//数据
			importData: { templateName: '', templateType: '', entityName: '' },
			Count: 0
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		switchTo(data, i) {
			this.tableDatays[i].mappingValue = '';
			this.tableDatays[i].sno = '';
			this.tableDatays[i].mappingExpression = '';
			this.tableDatays = JSON.parse(JSON.stringify(this.tableDatays));
		},
		SelectiveExecution(e, index) {
			this.options.forEach(v => {
				if (v.value == e) {
					this.tableDatays[index].mappingValue = v.label;
				}
			});
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('VoucherTemplatesoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('VoucherTemplatesheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		duplication(data, id) {
			let params = {};
			params.templateId = id;
			getTemplateConfig(params).then(res => {
				if (res.data.code == '200') {
					this.tableDatapz = JSON.parse(data.templateContent).map(v => {
						return { name: v.mappingValue, xuh: v.sno, mappingPrecision: v.mappingPrecision, dateFormat: v.dateFormat };
					});
					this.options = this.tableDatapz.map(v => {
						return {
							value: v.xuh,
							label: v.name
						};
					});
					this.options = JSON.parse(JSON.stringify(this.options));
					this.importData.templateName = null;
					this.importData.templateType = data.templateType;
					this.importData.entityName = data.entityName;
					this.importData.id = null;
					this.formdata = {
						textSplitType: data.textSplitType
					};
					this.upfile = {
						formdata: {
							textSplitType: data.textSplitType
						},
						filetype: data.suffixType
					};
					let params = {};
					params.entityName = data.entityName;
					getColumnNames(params).then(res1 => {
						if (res1.data.code == '200') {
							for (var i = 0; i < res1.data.data.length; i++) {
								for (var j = 0; j < res.data.data.length; j++) {
									if (res1.data.data[i].columnName == res.data.data[j].entityField) {
										res1.data.data[i].mappingType = res.data.data[j].mappingType;
										res1.data.data[i].mappingValue = res.data.data[j].mappingValue;
										res1.data.data[i].mappingExpression = res.data.data[j].mappingExpression;
										res1.data.data[i].mappingPrecision = res.data.data[j].mappingPrecision;
										res1.data.data[i].sno = res.data.data[j].sno;
									}
								}
							}
							this.tableDatays = res1.data.data;
							// this.Compilebc();
							this.Compile = true;
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		Compiletk(data, id) {
			if (id == '-1') {
				this.title = '新建模板';
				this.importData = { templateName: '', templateType: '', entityName: '' };
				this.formdata = {
					textSplitType: ''
				};
				this.upfile = {
					formdata: {
						textSplitType: ''
					}
				};
				this.options = [];
				this.tableDatays = [];
				// Object.keys(this.tableDatapz).map(key => (this.tableDatapz[key] = ''));
				this.tableDatapz = [];
				this.Compile = true;
			} else {
				this.title = '编辑模板';
				let params = {};
				params.templateId = id;
				getTemplateConfig(params).then(res => {
					if (res.data.code == '200') {
						this.tableDatapz = JSON.parse(data.templateContent).map(v => {
							return { name: v.mappingValue, xuh: v.sno, mappingPrecision: v.mappingPrecision, dateFormat: v.dateFormat };
						});
						this.options = this.tableDatapz.map(v => {
							return {
								value: v.xuh,
								label: v.name
							};
						});
						this.options = JSON.parse(JSON.stringify(this.options));
						this.importData.templateName = data.templateName;
						this.importData.templateType = data.templateType;
						this.importData.entityName = data.entityName;
						this.importData.id = data.id;
						this.formdata = {
							textSplitType: data.textSplitType
						};
						this.upfile = {
							formdata: {
								textSplitType: data.textSplitType
							},
							filetype: data.suffixType
						};
						let params = {};
						params.entityName = data.entityName;
						getColumnNames(params).then(res1 => {
							if (res1.data.code == '200') {
								for (var i = 0; i < res1.data.data.length; i++) {
									for (var j = 0; j < res.data.data.length; j++) {
										if (res1.data.data[i].columnName == res.data.data[j].entityField) {
											res1.data.data[i].mappingType = res.data.data[j].mappingType;
											res1.data.data[i].mappingValue = res.data.data[j].mappingValue;
											res1.data.data[i].mappingExpression = res.data.data[j].mappingExpression;
											res1.data.data[i].mappingPrecision = res.data.data[j].mappingPrecision;
											res1.data.data[i].sno = res.data.data[j].sno;
										}
									}
								}
								this.tableDatays = res1.data.data;
								this.Compile = true;
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			}
		},
		Compilebc() {
			// for (var i = 0; i < this.tableDatapz.length; i++) {
			// 	if (
			// 		(this.tableDatapz[i].mappingPrecision == '' || this.tableDatapz[i].mappingPrecision == null || this.tableDatapz[i].mappingPrecision == undefined) &&
			// 		(this.tableDatapz[i].dateFormat == '' || this.tableDatapz[i].dateFormat == null || this.tableDatapz[i].dateFormat == undefined)
			// 	) {
			// 		this.$message.error('请填写数据源表字段配置');
			// 		return;
			// 	}
			// }
			if (this.importData.templateName == '' || this.importData.templateName == null) {
				this.$message.error('请填写模板名称');
				return;
			}
			if (this.importData.templateType == '' || this.importData.templateType == null) {
				this.$message.error('请选择模板类型');
				return;
			}
			if (this.importData.entityName == '' || this.importData.entityName == null) {
				this.$message.error('请选择模板用途');
				return;
			}
			let bitian = JSON.parse(JSON.stringify(this.tableDatays[0].bitian));
			try {
				bitian.forEach(v => {
					this.tableDatays.forEach(vc => {
						if (vc.columnName == v) {
							if (vc.mappingType == '' || vc.mappingType == null) {
								this.$message.error('请选择 ' + vc.name + '的映射类型');
								throw new Error();
							}
							if (vc.mappingType == '1') {
								if (typeof vc.sno == 'string' || vc.sno == null) {
									this.$message.error('请选择 ' + vc.name + '的值');
									throw new Error();
								}
							} else if (vc.mappingType == '2') {
								if (vc.mappingValue == '' || vc.mappingValue == null) {
									this.$message.error('请填写 ' + vc.name + '的值');
									throw new Error();
								}
							} else if (vc.mappingType == '3') {
								if (vc.mappingExpression == '' || vc.mappingExpression == null) {
									this.$message.error('请填写 ' + vc.name + '的表达式');
									throw new Error();
								}
							}
						}
					});
				});
			} catch (e) {
				return;
			}

			let params = {};
			this.importData.suffixType = this.upfile.filetype;
			this.importData.textSplitType = this.upfile.formdata.textSplitType;
			this.importData.templateContent = JSON.stringify(
				this.tableDatapz.map(c => {
					if (c.mappingPrecision != '' && c.mappingPrecision != null && c.mappingPrecision != undefined) {
						return {
							mappingValue: c.name,
							sno: c.xuh,
							mappingPrecision: c.mappingPrecision
						};
					} else if (c.dateFormat != '' && c.dateFormat != null && c.dateFormat != undefined) {
						return {
							mappingValue: c.name,
							sno: c.xuh,
							dateFormat: c.dateFormat
						};
					} else {
						return {
							mappingValue: c.name,
							sno: c.xuh
						};
					}
				})
			);
			params.importData = JSON.stringify(this.importData);
			params.columnData = JSON.stringify(
				this.tableDatays.map(v => {
					v.entityField = v.columnName;
					v.entityClass = v.esseName;
					return v;
				})
			);
			params.fieldData = JSON.stringify(
				this.tableDatapz.map(c => {
					if (c.mappingPrecision != '' && c.mappingPrecision != null && c.mappingPrecision != undefined) {
						return {
							mappingValue: c.name,
							sno: c.xuh,
							mappingPrecision: c.mappingPrecision
						};
					} else if (c.dateFormat != '' && c.dateFormat != null && c.dateFormat != undefined) {
						return {
							mappingValue: c.name,
							sno: c.xuh,
							dateFormat: c.dateFormat
						};
					} else {
						return {
							mappingValue: c.name,
							sno: c.xuh
						};
					}
				})
			);
			saveOrUpdateMappingTemplateConfig(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('保存成功');
					this.searrchForData();
					this.Compile = false;
				} else {
					this.$message.error(res.data.message);
				}
			});

			// this.importData
		},
		dateFormatInputBox(i) {
			if (this.tableDatapz[i].mappingPrecision != '' && this.tableDatapz[i].mappingPrecision != null && this.tableDatapz[i].mappingPrecision != undefined) {
				this.tableDatapz[i].dateFormat = '';
				this.$message.error('日期格式和精度两者不能同时填写');
			}
		},
		mappingPrecisionInputBox(i) {
			if (this.tableDatapz[i].dateFormat != '' && this.tableDatapz[i].dateFormat != null && this.tableDatapz[i].dateFormat != undefined) {
				this.tableDatapz[i].mappingPrecision = '';
				this.$message.error('日期格式和精度两者不能同时填写');
			}
		},
		currStationChange(e) {
			let params = {};
			params.entityName = e;
			getColumnNames(params).then(res => {
				if (res.data.code == '200') {
					this.tableDatays = res.data.data;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//导入
		forsubmit(e) {
			if (this.upfile.filetype == 'txt' || this.upfile.filetype == 'csv') {
				if (e.formdata.textSplitType == '') {
					this.$message.error('请输入分割字符');
					return false;
				}
			}
			if (this.$emptyandnull(this.upfile.upfilename)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			this.upfile.formdata = e.formdata;
			let params = {};
			params.uploadFile = [];
			params.uploadFile[0] = this.upfile.upfile;
			params.textSplitType = e.formdata.textSplitType;
			uploadTemplateText(params).then(res => {
				if (res.data.code == '200') {
					this.tableDatapz = res.data.data;
					this.options = res.data.data.map(v => {
						return {
							value: v.xuh,
							label: v.name
						};
					});
					this.options = JSON.parse(JSON.stringify(this.options));
					this.closeupdiag();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		closeupdiag() {
			this.updiag = false;
		},
		getuploadparams(e) {
			this.upfile = e;
		},
		//删除
		deleteTCode(id) {
			if (this.$refs.tablebox.getSelectionval().length == 0 && id == '-1') {
				this.$message.error('请选择要删除的数据');
				return;
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					if (id != '-1') {
						params.templateID = id;
					} else {
						params.templateID = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
					}

					deleteMappingTemplateConfig(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = 'id';
			params.order = 'desc';
			templategetTemplate(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data.map(v => {
						v.createTime = this.formatDate(v.createTime);
						return v;
					});
					this.pagination.total = res.data.count;
				}
			});
		},
		formatDate(value) {
			// 时间戳转换日期格式方法
			if (value == null || value == '' || value.length != 14) {
				return value;
			} else {
				const y = value.substr(0, 4); // 年
				let MM = value.substring(4, 6); // 月
				let d = value.substring(6, 8); // 日
				let hh = value.substring(8, 10); // 小时
				let mm = value.substring(10, 12); // 分钟
				let ss = value.substring(12, 14); // 秒
				return y + '-' + MM + '-' + d + ' ' + hh + ':' + mm + ':' + ss;
			}
		},
		$yyyyMM: function(value) {
			if (value === undefined || value === null || value === '') {
				return '';
			}
			return value.substring(0, 4) + '年' + value.substring(4, 6) + '期';
		},
		$yyyyMMdd: function(value) {
			if (value === undefined || value === null || value === '') {
				return '';
			}
			return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8);
		},
		$yyyyMMddxg: function(value) {
			if (value === undefined || value === null || value === '') {
				return '';
			}
			return value.substring(0, 4) + '/' + value.substring(4, 6) + '/' + value.substring(6, 8);
		},

		geOoverLength(e) {
			this.overlength = e;
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
